export default __webpack_public_path__ + "static/media/digitalmedia.15676306.png";